import React, { useContext, useState } from 'react';
import Section from '../../../UIcomponent/Section';
import Col from '../../../UIcomponent/Column';
import './TeacherBook.scss';
import LocalContext from '../../../Context/LocalContetxt';
import TeacherBookDic from './TeacherBookDic';
import { PublicDic } from '../../../Utility/PublicDic';
import StyledButton from '../../../UIcomponent/Button';
import Question from '../../../UIcomponent/Icon/Question';
import LocalBooking from '../../../Utility/Method/LocalBooking';
import { ConfigContext } from 'antd/lib/config-provider/context';
import Modal from '../../../UIcomponent/Modal';
import LoginRegister from '../../../Component/LoginRegister/LoginRegister';
const TeacherBook = (props) => {
  const lang = useContext(LocalContext).lang;
  const { intro, disable, id } = props;
  const [showRegister, setShowRegister] = useState(false);
  const hasToken = useContext(LocalContext).hasToken;

  const BookModalShowHandler = () => {
    if (!hasToken) {
      setShowRegister(true);
      return;
    }
    props.setShowBookModal(true);

    // window.location.href = `/teachers/${id}/book`;
  };
  let price = {
    minPrice: intro != null && (intro.MinPrice || 0),
    trialPrice: intro != null && (intro.TrialPrice || 0),
  };
  let loading = intro ? false : true;
  return (
    <Section lang={lang} className="c__TeacherBook">
      {hasToken === false && showRegister && (
        <Modal visible={showRegister} onCancel={(_) => setShowRegister(false)}>
          <LoginRegister mode={'register'} />
        </Modal>
      )}
      <Col
        className="c__TeacherBook__TryoClass"
        xl={21}
        lg={21}
        md={21}
        sm={21}
        xs={21}
        skeletonType="line"
        loading={loading}
      >
        {intro && (
          <>
            <Col
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="c__TryoClass__Tip"
            >
              {TeacherBookDic.tryoClass[`${lang}`]}
              <Col className="o__TryoClass__Tip__Icon">
                <Question />
                <Col className="o__TryoClass__Tip__Desc">
                  کلاس آزمایشی به مدت 30 دقیقه و با هزینه کم ، روش مناسبی برای
                  آشنایی با نحوه کار لینگوتاک است.
                </Col>
              </Col>
            </Col>
            <Col
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="c__TryoClass__Price"
            >
              رایگان
            </Col>
          </>
        )}
      </Col>
      {
        <Col
          xl={21}
          lg={21}
          md={21}
          sm={21}
          xs={21}
          height="auto"
          loading={loading}
        >
          {intro && <span className="tryo_session__H__Divider"></span>}
        </Col>
      }
      <Col
        className="c__TeacherBook__Session"
        xl={21}
        lg={21}
        md={21}
        sm={21}
        xs={21}
        skeletonType="line"
        loading={loading}
      >
        {intro && (
          <>
            <Col
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="c__Session__Count"
            >
              شروع قیمت از ساعتی
            </Col>
            <Col
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="c__Session__Price"
            >
              {price &&
                (price.minPrice / 10).toLocaleString(lang) +
                  ' ' +
                  PublicDic.Toman}
            </Col>
          </>
        )}
      </Col>
      <Col
        xl={21}
        lg={21}
        md={21}
        sm={21}
        xs={21}
        className="c__TeacherBook__Button"
      >
        {intro ? (
          <StyledButton
            primary
            width="100%"
            height="50px"
            onClick={BookModalShowHandler}
            disable={disable}
            id={`booking_button_TeacherID:${id}`}
          >
            {props.hadTrial
              ? TeacherBookDic.reserve[`${lang}`]
              : 'رزرو اولین جلسه رایگان'}
          </StyledButton>
        ) : (
          <Col
            style={{
              height: '50px',
              width: '100%',
            }}
            loading={loading}
          ></Col>
        )}
      </Col>
    </Section>
  );
};

export default TeacherBook;
